import type { FlexStyledProps, GetStyles } from '@sds-system/types';

export const getFlexStyles: GetStyles<FlexStyledProps> = ({
  alignItems,
  flex,
  flexDirection,
  justifyContent,
  display,
  flexCenter,
}) => {
  return {
    ...(flexCenter && { display: 'flex', justifyContent: 'center', alignItems: 'center' }),
    ...(display && { display }),
    ...(justifyContent && { justifyContent }),
    ...(flexDirection && { flexDirection }),
    ...(alignItems && { alignItems }),
    ...(flex && { flex }),
  };
};
